<template>
    <ItemMenuWrapper v-slot="{ inputId }" :label="label">
        <span class="icon-right">
            <ColorPicker ref="pickerOverlayRef" @update:modelValue="handleUpdate" type="color" :modelValue="colorValue" class="color-input" />
            <InputText :id="inputId" style="width: 100%" :modelValue="displayValue" @update:modelValue="handleUpdate" placeholder="#ffffff" />
        </span>
    </ItemMenuWrapper>
</template>

<script setup>
import ItemMenuWrapper from './ItemMenuWrapper.vue';
import { defineProps, defineEmits, ref, computed } from 'vue';

const props = defineProps({
    label: String,
    modelValue: {
        type: String,
        default: '#ffffff',
    },
});

const emit = defineEmits(['update:modelValue']);
const pickerOverlayRef = ref(null);

const colorValue = computed(() => (props.modelValue || '#ffffff').replace('#', ''));

const displayValue = computed(() => props.modelValue || '#ffffff');

const handleUpdate = (value) => {
    const cleanValue = String(value || '').replace(/^#+/, '');
    emit('update:modelValue', cleanValue ? `#${cleanValue}` : '#ffffff');
};
</script>

<style lang="scss" scoped>
.icon-right {
    display: flex;
    align-items: center;
    .material-symbols-outlined {
        right: 0.5rem;
        background: white;
    }
}

.color-input {
    width: 44px;
    padding-left: 3px;
    cursor: pointer;
    background: none;
}

.color-text {
    flex: 1;
    box-sizing: border-box;
}
</style>
